var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5303 3.53033C21.8232 3.23744 21.8232 2.76256 21.5303 2.46967C21.2374 2.17678 20.7626 2.17678 20.4697 2.46967L11.1792 11.7601C10.1632 10.9703 8.88653 10.5 7.5 10.5C4.18629 10.5 1.5 13.1863 1.5 16.5C1.5 19.8137 4.18629 22.5 7.5 22.5C10.8137 22.5 13.5 19.8137 13.5 16.5C13.5 15.1135 13.0297 13.8368 12.2399 12.8208L16.5 8.56066L18.9697 11.0303C19.2626 11.3232 19.7374 11.3232 20.0303 11.0303L23.0303 8.03033C23.3232 7.73744 23.3232 7.26256 23.0303 6.96967L20.5607 4.5L21.5303 3.53033ZM19.5 9.43934L17.5607 7.5L19.5 5.56066L21.4393 7.5L19.5 9.43934ZM12 16.5C12 18.9853 9.98528 21 7.5 21C5.01472 21 3 18.9853 3 16.5C3 14.0147 5.01472 12 7.5 12C9.98528 12 12 14.0147 12 16.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/key.78d09590923bb1aca609894af030d047.svg";